import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

export default createVuetify({
  components,
  directives,
  theme: {
    themes: {
      light: {
        colors: {
          primary: "#b41502",
          secondary: "#211f1f",
          tertiary: "#989898",
          rich_gold: "#d4af37",
          pale_champagne: "#f7f1e5",
          soft_ivory: "#fffff0",
          dark_charcoal: "#2c2c2c",
          off_white: "#FAF9F6"
        }
      }
    }
  }
});
